<template>
  <gmap-marker
    v-if="item.latlon && !checkAgainstSearch()"
    ref="marker"
    :key="index"
    :position="item.latlon"
    :clickable="true"
    :draggable="false"
    :icon="icon"
    @click="handleClick"
  >
  </gmap-marker>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },

  computed: {
    ...mapState('Results', {
      titleSearchTerm: (state) => state.titleSearchTerm,
      idSubset: (state) => state.idSubset
    }),
    icon() {
      return `/themes/asvz_next/public/images/icons/marker${
        this.item.is_asvz_sport_center ? '-asvz' : ''
      }.svg`
    }
  },

  methods: {
    /* todo move to item class */
    checkAgainstSearch() {
      return (
        this.titleSearchTerm &&
        this.titleSearchTerm.length > 0 &&
        this.item.title.search(new RegExp(this.titleSearchTerm, 'i')) === -1
      )
    },
    handleClick() {
      this.$refs.marker.$markerObject.map.panTo(
        this.$refs.marker.$markerObject.getPosition()
      )
      this.$store.dispatch('Facilities/showInfoWindow', this.item)
    }
  }
}
</script>
